import React, { useState, useRef, useEffect, createRef, useMemo } from 'react'
import Field from '../../Field/Field'
import TextInput from '../../TextInput/TextInput'
import FieldLabel from '../../FieldLabel/FieldLabel'
// import Checkbox from '../../Checkbox/Checkbox'
import Radio from '../../Radio'
import Dropdown from '../../DropDown/Dropdown'
import Help from '../../Help/Help'
import Textarea from '../../Textarea/Textarea'
import ToggleSwitch from '../../ToggleSwitch/ToggleSwitch'
import Button from '../../Button/Button'
import Pills from '../../Pills/Pill'
import Icon from '../../Icon2'
import Tooltip from '../../Tooltip/Tooltip'
import arrayMove from 'array-move'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { fieldUidRegex, getContentTypeFieldDataTestId, CONTENT_TYPE_FIELD_ACTION_IDS, NonLocalizableDom, handleToggleClick, checkNodeForDuplicateChoice } from '../helper'
import { booleanTestIdFormatter } from './../../../utils/helpers'
import { cloneDeep } from 'lodash'
import ModularBlockInstanceTitleToggle from "../HelperComponents/ModularBlockInstanceTitleToggle"
import GlobalFieldTitleToggle from "../HelperComponents/GlobalFieldTitleToggle"
// import { isEnterPressed } from 'utils/keyboardUtils'


const SortableItem = (props) => {
  const { t, schema, uniqueKey, field_metadata, type, onOptionsUpdateError, onchange }: any = props
  const defaultOptions = Array.isArray(field_metadata.default_value)
    ? cloneDeep(field_metadata)
    : {
      default_value:
        field_metadata.default_value || field_metadata.default_value === 0 ? [field_metadata.default_value] : [],
      default_key: field_metadata.default_key || field_metadata.default_key === 0 ? [field_metadata.default_key] : []
    }


  const onAddChoiceChange = (event: any, idx: any, key: boolean) => {
    let defaultIndex;
    if (key) {
      defaultIndex = defaultOptions.default_key.indexOf(schema.enum.choices[idx].key)
    } else {
      defaultIndex = defaultOptions.default_value.indexOf(schema.enum.choices[idx].value)
    }
    //remove default key and value if it is changed
    if (defaultIndex > -1) {
      defaultOptions.default_value.splice(defaultIndex, 1)
      field_metadata.default_value = defaultOptions.default_value.length > 1 ? defaultOptions.default_value : (defaultOptions.default_value[0] || defaultOptions.default_value === 0 ? defaultOptions.default_value[0] : '')
      if (key) {
        defaultOptions.default_key.splice(defaultIndex, 1)
        field_metadata.default_key = defaultOptions.default_key.length > 1 ? defaultOptions.default_key : (defaultOptions.default_key[0] || defaultOptions.default_key === 0 ? defaultOptions.default_key[0] : '')
      }
    }

    //checking if the new value is already present in the schema
    let hasDuplicate = false
    for (let i = 0; i < schema.enum.choices.length; i++) {
      if (key && schema.enum.choices[i].key.toString() === event.target.value) {
        hasDuplicate = true
        break
      } else if (!key && schema.enum.choices[i].value.toString() === event.target.value) {
        hasDuplicate = true
        break
      }
    }

    //assinging new value to the schema
    if (key) {
      schema.enum.choices[idx].key = event.target.value
    } else {
      schema.enum.choices[idx].value = schema.data_type === 'number' ? parseInt(event.target.value) : event.target.value
    }

    //checking if the new value is empty
    let isEditKeyValueEmpty = false
    let isEditValueEmpty = false
    if (event.target.value.toString().trim() === '') {
      schema.enum.advanced ? (isEditKeyValueEmpty = true) : (isEditValueEmpty = true)
    }

    if (hasDuplicate) {
      schema.error_details = {
        ...schema.error_details,
        duplicate_choice_data: 'The choices cannot be same'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        duplicate_choice_data: ''
      }
    }
    if (isEditKeyValueEmpty) {
      schema.error_details = {
        ...schema.error_details,
        empty_choice_data: 'Value or Key cannot be empty'
      }
      schema.error = true
    } else if (isEditValueEmpty) {
      schema.error_details = {
        ...schema.error_details,
        empty_choice_data: 'Value cannot be empty'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        empty_choice_data: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }

    onOptionsUpdateError()
    onchange()
  }

  const radioTooltip: any = props.t('global_field.content_type_edit.body.fields.select.item.tooltip_text.default')
  const handleDelete = (e: any, schema: any, field_metadata: any, props: any, onOptionsUpdateError: () => void, onchange: () => void) => {
    e?.preventDefault()
    e?.stopPropagation()
    const optIndex = defaultOptions.default_value.indexOf(schema.enum.choices[props.indexVal].value)
    if (optIndex > -1) {
      defaultOptions.default_value.splice(optIndex, 1)
      field_metadata.default_value = defaultOptions.default_value.length > 1 ? defaultOptions.default_value : (defaultOptions.default_value[0] || defaultOptions.default_value === 0 ? defaultOptions.default_value[0] : '')
      if (schema.enum.advanced) {
        defaultOptions.default_key.splice(optIndex, 1)
        field_metadata.default_key = defaultOptions.default_key.length > 1 ? defaultOptions.default_key : (defaultOptions.default_key[0] || defaultOptions.default_key === 0 ? defaultOptions.default_key[0] : '')
      }
    }
    schema.enum.choices.splice(props.indexVal, 1)
    onOptionsUpdateError()
    onchange()
  }

  const max = schema.max_instance || schema.enum.choices.length
  const disabled = schema.multiple
    ? defaultOptions.default_value.length >= max && !defaultOptions.default_value?.includes(props.item.value)
      ? true
      : false
    : false

  return (
    <Draggable draggableId={`${uniqueKey}.${props.indexVal}`} index={props.index}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          className={`SelectField__choice-list flex-justify ${defaultOptions.default_value.includes(props.item.value) ? 'SelectField__choice--default' : ''
            }`}>
          <div className="SelectField__drag-icon" {...provided.dragHandleProps}>
            <Icon icon="DotsSixVertical" size="medium" version="v2" />
          </div>
          {schema.enum.advanced ? (
            <div className="SelectField__key-value-choice">
              <TextInput
                version="v2"
                name={`${uniqueKey}.addchoices.${props.index}.key`}
                value={props.item.key}
                type={'text'}
                placeholder={'Enter key here'}
                // onKeyUp={(e) => onAddChoiceChange(e, props.indexVal, true)}
                onInput={(e) => onAddChoiceChange(e, props.indexVal, true)}
                // onBlur={onchange}
                error={schema?.enum?.choices[props.index]?.key?.length > 0 ? false : true}
                testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.CHOICES_KEY_INPUT)}
              />
              <span className="colon-seperator">:</span>
              <TextInput
                version="v2"
                name={`${uniqueKey}.addchoices.${props.index}.value`}
                value={props.item.value}
                type={schema.data_type}
                placeholder={'Enter value here'}
                onInput={(e) => onAddChoiceChange(e, props.indexVal, false)}
                // onBlur={onchange}
                error={
                  (schema.data_type === 'number' && schema?.enum?.choices[props.index]?.value > 0) ||
                    schema?.enum?.choices[props.index]?.value.length > 0
                    ? false
                    : true
                }
                // error={typeof props.item.value === 'undefined' ? true : undefined}
                testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.CHOICES_VALUE_INPUT)}
                suffixVisible
                suffix={
                  defaultOptions.default_value.includes(props.item.value) && (
                    <Pills
                      status="warning"
                      variant="chip"
                      items={[
                        {
                          id: props.indexVal,
                          text: 'Default'
                        }
                      ]}
                      shouldHaveBorder={false}
                    />
                  )
                }
              />
            </div>
          ) : (
            <TextInput
              version="v2"
              name={`${uniqueKey}.addchoices.${props.index}`}
              value={props.item.value}
              type={schema.data_type}
              placeholder={'Enter value here'}
              onInput={(e) => onAddChoiceChange(e, props.indexVal, false)}
              error={
                (schema.data_type === 'number' && schema?.enum?.choices[props.index]?.value > 0) ||
                  schema?.enum?.choices[props.index]?.value.length > 0
                  ? false
                  : true
              }
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.CHOICES_INPUT)}
              suffixVisible
              suffix={
                defaultOptions.default_value.includes(props.item.value) && (
                  <Pills
                    status="warning"
                    variant="chip"
                    items={[
                      {
                        id: props.indexVal,
                        text: 'Default'
                      }
                    ]}
                    shouldHaveBorder={false}
                  />
                )
              }
            />
          )}

          <div>
            <Dropdown
              testId="cs-option-default-dropdown"
              list={[
                {
                  label: (
                    <div className={`flex-v-center ${disabled ? 'disabled' : ''}`}>
                      <Icon
                        icon={
                          defaultOptions.default_value?.includes(props.item.value) ? 'DontSave' : 'CheckSquareOffset'
                        }
                        version="v2"
                        size="medium"
                        className="mr-10"
                      />
                      <div>
                        {defaultOptions.default_value?.includes(props.item.value)
                          ? 'Remove as Default'
                          : 'Mark as Default'}
                      </div>
                    </div>
                  ),
                  testId: 'cs-ct-field-select-default',
                  disable: disabled,
                  action: (event: any) => {
                    if (defaultOptions.default_value?.includes(props.item.value)) {
                      defaultOptions.default_value = defaultOptions.default_value.filter(
                        (value) => value !== props.item.value
                      )
                      field_metadata.default_value = defaultOptions.default_value.length > 1 ? defaultOptions.default_value : (defaultOptions.default_value[0] || defaultOptions.default_value === 0 ? defaultOptions.default_value[0] : '');
                      if (schema.enum.advanced) {
                        defaultOptions.default_key = defaultOptions.default_key.filter((key) => key !== props.item.key)
                        field_metadata.default_key = defaultOptions.default_key.length > 1 ? defaultOptions.default_key : (defaultOptions.default_key[0] || defaultOptions.default_key === 0 ? defaultOptions.default_key[0] : '');
                      }
                    } else {
                      if (schema.multiple === false) {
                        defaultOptions.default_value = [props.item.value]
                        field_metadata.default_value = props.item.value
                        if (schema.enum.advanced) {
                          defaultOptions.default_key = [props.item.key]
                          field_metadata.default_key = props.item.key
                        }
                      } else {
                        defaultOptions.default_value.push(props.item.value)
                        field_metadata.default_value = defaultOptions.default_value.length > 1 ? defaultOptions.default_value : defaultOptions.default_value[0];
                        if (schema.enum.advanced) {
                          defaultOptions.default_key.push(props.item.key)
                          field_metadata.default_key =
                            defaultOptions.default_key.length > 1
                              ? defaultOptions.default_key
                              : defaultOptions.default_key[0]
                        }
                      }
                    }
                    onchange()
                  }
                },
                {
                  label: (
                    <div className="flex-v-center">
                      <Icon icon="Delete" version="v2" size="medium" className="mr-10" />
                      <div>Delete</div>
                    </div>
                  ),
                  testId: getContentTypeFieldDataTestId(
                    schema,
                    type,
                    CONTENT_TYPE_FIELD_ACTION_IDS.DELETE_CHOICE_BUTTON
                  ),
                  action: (e) => {
                    handleDelete(e, schema, field_metadata, props, onOptionsUpdateError, onchange)
                  }
                }
              ]}
              type="click"
              dropDownPosition="left"
              className="SelectField__optionMenu"
              version="v2"
              closeAfterSelect>
              <Icon icon="DotsThreeLargeVertical" size="medium" version="v2" />
            </Dropdown>
          </div>
        </div>
      )}
    </Draggable>
  )
}

const SortableList = ({ choices, t, schema, uniqueKey, field_metadata, type, onOptionsUpdateError, onchange }) => {
  return (
    <div className="SelectField__choices">
      {choices.map((item, index) => {
        return (
          <div key={`item-${index}`} className='w-100'>
            <SortableItem t={t}
              key={`item-${index}`}
              item={item}
              index={index}
              indexVal={index}
              schema={schema}
              uniqueKey={uniqueKey}
              field_metadata={field_metadata}
              type={type}
              onOptionsUpdateError={onOptionsUpdateError}
              onchange={onchange} />
          </div>
        )
      })}
    </div>
  )
}

export const SelectField = (props: any) => {
  const {
    onChange,
    parentInfo,
    uniqueKey,
    schema,
    type,
    selectAsNumberText,
    selectAsKeyValue,
    selectAsSingle,
    selectOptionsLimit,
    isNonLocalizable,
    hasNonLocalizablePlan,
    hasNonLocalizablePlanForBlocksAndGroupMultiple,
    contentTypeSchemaTree,
    isGlobalFieldBuilderPage
  } = props
  const [initialSchema, setSchema] = useState(schema)
  const { display_name, uid, field_metadata } = schema

  const [choices, setChoices] = useState('')
  const [error, setError] = useState(fieldUidRegex(schema.uid, schema))

  const displayNameRef: any = useRef(null)

  useEffect(() => {
    displayNameRef.current.focus()
  }, [displayNameRef])

  const onchange = () => {
    onChange && onChange(schema)
    onOptionsUpdateError()
    setSchema({ ...schema })
  }
  const onDisplayNameChange = (event: any) => {
    schema.display_name = event.target.value

    if (schema.hasOwnProperty('display_name') && schema.newfield) {
      schema.uid = schema.display_name
        .trim()
        .replace(/[^A-Z0-9]+/gi, '_')
        .toLowerCase()
      if (schema.display_name) {
        schema.error_details = {
          ...schema.error_details,
          uid: ''
        }
      }
    }

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.display_name.length) {
      schema.error_details = {
        ...schema.error_details,
        display_name: 'Display Name cannot be empty'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        display_name: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }

  const onUidChange = (event: any) => {
    setError(fieldUidRegex(event.target?.value?.trim(), schema))

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.uid.length) {
      schema.error_details = {
        ...schema.error_details,
        uid: 'uid cannot be empty'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        uid: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onInstructionChange = (event: any) => {
    field_metadata.instruction = event.target.value
    onchange()
  }
  const onChoicesChange = (event: any) => {
    setChoices(event.target.value)
  }
  const onHelpTextChange = (event: any) => {
    field_metadata.description = event.target.value
    onchange()
  }
  const onOptionsChange = (event: any) => {
    if (event.target.name === `${uniqueKey}.mandatory`) {
      schema.mandatory = event.target.checked
    }
    if (event.target.name === `${uniqueKey}.nonLocalization`) {
      if (event.target.checked && parentInfo.hasParent && hasNonLocalizablePlanForBlocksAndGroupMultiple) {
        handleToggleClick(event, parentInfo.data_type, schema, onchange, 'nonLocalizable', props.t , parentInfo.isInsideMultiple ,parentInfo.ancestorWithMultipleType)
      }
      else {
        schema.non_localizable = event.target.checked
      }
    }
    onchange()
  }
  const onLimitMinChange = (event: any) => {
    schema.min_instance = parseInt(event.target.value)

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (schema.min_instance < 0 || schema.min_instance > schema.max_instance) {
      schema.error_details = {
        ...schema.error_details,
        min_instance: 'min instance cannot be greater than max instance'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        min_instance: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onLimitMaxChange = (event: any) => {
    schema.max_instance = event.target.value ? parseInt(event.target.value) : null

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (schema.max_instance < 0 || schema.max_instance < schema.min_instance) {
      schema.error_details = {
        ...schema.error_details,
        max_instance: 'max instance cannot be lower than min instance'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        max_instance: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onDataTypeChoiceChange = (event: any) => {
    let value = event.target.value
    if (schema.enum.choices.length) {
      selectAsNumberText(() => {
        if (schema.field_metadata) {
          schema.field_metadata.default_value = ''
          if (schema.enum.advanced) {
            schema.field_metadata.default_key = ''
          }
        }
        schema.enum.choices = []

        if (value === 'text') {
          schema.data_type = 'text'
        } else {
          schema.data_type = 'number'
        }

        onchange()
      })
    } else {
      if (value === 'text') {
        schema.data_type = 'text'
      } else {
        schema.data_type = 'number'
      }

      onchange()
    }
  }
  const selectionType = [
    {
      label: 'Single Choice',
      action: () => {
        if (Array.isArray(field_metadata.default_value) && field_metadata.default_value.length > 1) {
          selectAsSingle(() => {
            if (schema.field_metadata) {
              schema.field_metadata.default_value = ''
              if (schema.enum.advanced) {
                schema.field_metadata.default_key = ''
              }
            }
            schema.multiple = false
            if (schema.display_type === 'checkbox') {
              schema.display_type = 'radio'
            }
            if (schema.max_instance) {
              schema.max_instance = null
            }
            if (schema.min_instance) {
              schema.min_instance = null
            }
            onchange()
          },
            schema,
            () => {
              schema.multiple = true
              onchange()
            })
        } else {
          schema.multiple = false
          if (schema.display_type === 'checkbox') {
            schema.display_type = 'radio'
          }
          if (schema.max_instance) {
            schema.max_instance = null
          }
          if (schema.min_instance) {
            schema.min_instance = null
          }
          onchange()
        }
      },
      default: !schema.multiple
    },
    {
      label: 'Multiple Choices',
      action: () => {
        schema.multiple = true
        if (schema.display_type === 'radio') {
          schema.display_type = 'checkbox'
        }

        onchange()
      },
      default: schema.multiple
    }
  ]
  const displayType = [
    {
      label: 'Dropdown',
      action: () => {
        schema.display_type = 'dropdown'
        onchange()
      },
      default: schema.display_type === 'dropdown'
    },
    {
      label: `${schema.multiple ? 'Checkbox' : 'Radio'}`,
      action: () => {
        schema.display_type = `${schema.multiple ? 'checkbox' : 'radio'}`
        onchange()
      },
      default: schema.display_type === 'checkbox' || schema.display_type === 'radio'
    }
  ]

  const onAddChoices = (event: any) => {
    event.preventDefault()
    if (choices) {
      let newValue = choices

      var hasDuplicate = schema.enum.choices.filter((fi) => {
        return newValue.split('\n').filter((val) => {
          let keyValueChoiceData = val.split(':')
          if (schema.enum.advanced) {
            return keyValueChoiceData[1]?.trim() == fi.value || keyValueChoiceData[0]?.trim() == fi.key
          } else {
            return val.trim() == fi.value
          }
        }).length
      }).length
      if (!hasDuplicate) {
        var hasNewDuplicate = newValue.split('\n').filter((newVal, i) => {
          return newValue.split('\n').filter((val, j) => {
            while (i !== j) {
              if (schema.enum.advanced) {
                return (
                  val.split(':')[1]?.trim() == newVal.split(':')[1]?.trim() ||
                  val.split(':')[0]?.trim() == newVal.split(':')[0]?.trim()
                )
              } else {
                return val.trim() == newVal.trim()
              }
            }
          }).length
        }).length
      }

      if (schema.enum.advanced) {
        var isNewKeyValueEmpty = newValue.split('\n').filter((val) => {
          let keyValueChoiceData = val.split(':')
          return keyValueChoiceData[1]?.trim() === '' || keyValueChoiceData[0]?.trim() === ''
        }).length
      } else {
        var isNewValueEmpty = newValue.split('\n').filter((val) => {
          return val.trim() === ''
        }).length
      }

      if (hasDuplicate) {
        schema.error_details = {
          ...schema.error_details,
          duplicate_choice: 'The new choice cannot be same as any existing choice'
        }
        schema.error = true
      } else if (hasNewDuplicate) {
        schema.error_details = {
          ...schema.error_details,
          duplicate_choice: 'The new choices cannot be same'
        }
        schema.error = true
      } else if (isNewKeyValueEmpty) {
        schema.error_details = {
          ...schema.error_details,
          empty_new_choice_data: 'Value or Key cannot be empty'
        }
        schema.error = true
      } else if (isNewValueEmpty) {
        schema.error_details = {
          ...schema.error_details,
          empty_new_choice_data: 'Value cannot be empty'
        }
        schema.error = true
      } else {
        schema.error_details = {
          ...schema.error_details,
          duplicate_choice: '',
          empty_new_choice_data: ''
        }
        schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
          ? true
          : false
      }

      if (schema.enum.choices.length + newValue.split('\n').length > selectOptionsLimit) {
        schema.error_details = {
          ...schema.error_details,
          max_choices: `The maximum choices cannot be greater than ${selectOptionsLimit}`
        }
        schema.error = true
      } else {
        schema.error_details = {
          ...schema.error_details,
          max_choices: ''
        }
        schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
          ? true
          : false
      }

      newValue.split('\n').filter((val: any) => {
        let keyValueChoiceData: any = val.split(':')
        if (
          (schema.enum.advanced && schema.data_type == 'number' && isNaN(keyValueChoiceData[1]?.trim())) ||
          (!schema.enum.advanced && schema.data_type == 'number' && isNaN(val))
        ) {
          schema.error_details = {
            ...schema.error_details,
            add_choices: 'Only number values are allowed'
          }
          schema.error = true
          onchange()
          return false
        } else {
          schema.error_details = {
            ...schema.error_details,
            add_choices: ''
          }
          schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
            ? true
            : false
        }
      })

      if (!hasDuplicate && !hasNewDuplicate && !isNewKeyValueEmpty && !isNewValueEmpty) {
        let allchoices = newValue.split('\n').map((item) => {
          if (item.length) {
            if (schema.enum.advanced) {
              let keyValueChoiceData = item.split(':')
              if (schema.data_type == 'number') {
                return {
                  value: Number(keyValueChoiceData[1].trim()),
                  key: keyValueChoiceData[0].trim()
                }
              } else {
                return {
                  value: keyValueChoiceData[1].trim(),
                  key: keyValueChoiceData[0].trim()
                }
              }
            } else {
              if (schema.data_type == 'number') {
                return {
                  value: Number(item.trim())
                }
              } else {
                return {
                  value: item.trim()
                }
              }
            }
          }
        })

        if (
          schema.error_details &&
          !schema.error_details.add_choices &&
          !schema.error_details.max_choices &&
          !schema.error_details.empty_new_choice_data
        ) {
          schema.enum.choices.push(...allchoices)
          setChoices('')
          if (schema.enum.advanced) {
            schema.mixPanel = true
            schema.mixPanelEventName = 'Add Key-Value Choices'
          }
        }
      }

      onchange()
    }
  }

  const onOptionsUpdateError = () => {
    // Check for duplicates within schema.enum.choices

    let hasDuplicate = checkNodeForDuplicateChoice(schema)
    
    // Set duplicate error if found
    if (hasDuplicate) {
      schema.error_details = {
        ...schema.error_details,
        duplicate_choice_data: 'The choices cannot be same'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        duplicate_choice_data: ''
      }
    }
    
    if (schema.enum.choices.length < schema.min_instance) {
      schema.error_details = {
        ...schema.error_details,
        min_instance: 'The minimum limit for multiple choices cannot be greater than the total number of choices'
      }
      schema.error = true
    } else if (schema.max_instance && schema.min_instance && schema.max_instance < schema.min_instance) {
      schema.error_details = {
        ...schema.error_details,
        min_instance:
          'The minimum limit for multiple choices cannot be greater than the maximum limit for multiple choices'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        min_instance: ''
      }
    }

    if (schema.enum.choices.length < schema.max_instance) {
      schema.error_details = {
        ...schema.error_details,
        max_instance: 'The maximum limit for multiple choices cannot be greater than the total number of choices'
      }
      schema.error = true
    } else if (schema.max_instance && schema.min_instance && schema.max_instance < schema.min_instance) {
      schema.error_details = {
        ...schema.error_details,
        max_instance:
          'The maximum limit for multiple choices cannot be less than the minimum limit for multiple choices'
      }
      schema.error = true
    } else if (
      schema.max_instance > 0 &&
      schema.max_instance <
      (Array.isArray(field_metadata.default_value)
        ? field_metadata.default_value.length
        : field_metadata.default_value || field_metadata.default_value === 0
          ? 1
          : 0)
    ) {
      schema.error_details = {
        ...schema.error_details,
        max_instance: 'The maximum limit for multiple choices cannot be less than the number of default values'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        max_instance: ''
      }
    }

    schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
      ? true
      : false
  }

  const onKeyValueToggle = () => {
    selectAsKeyValue(schema, () => {
      schema.enum.choices = []
      field_metadata.default_value = ''

      if (schema.enum.advanced) {
        delete field_metadata.default_key
        schema.enum.advanced = false
      } else {
        field_metadata.default_key = ''
        schema.enum.advanced = true
      }

      setChoices('')
      onchange()
    })
  }

  if (type === 'basic') {
    return (
      <>
        <div className='FormFields'>
          <Field>
            <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_NAME_INPUT)}-label`} className='FieldLabel__CT' version="v2" required htmlFor="displayName">
              Display Name
            </FieldLabel>
            <TextInput
              required
              name={`${uniqueKey}.displayName`}
              value={display_name}
              onChange={onDisplayNameChange}
              inputRef={displayNameRef}
              error={schema.error && schema.error_details.display_name ? true : false}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              version="v2"
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_NAME_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}-label`} className='FieldLabel__CT' required htmlFor="uid" version="v2">
              Unique ID
            </FieldLabel>
            <Help type="basic" text="A unique ID for this field. This should not be same as the ID of any other field in this content type." />
            <TextInput
              required
              name={`${uniqueKey}.uid`}
              value={uid}
              onChange={onUidChange}
              error={(schema.error && schema.error_details.uid) || error ? true : false}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              version="v2"
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}
            />
          </Field>

          <Field>
            <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}-label`} className='FieldLabel__CT' htmlFor="instruction" version="v2">Instruction Value</FieldLabel>
            <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}-help-text`} text="Helps you add instructions for this field. The instructional text will appear below the field." />
            <Textarea
              name={`${uniqueKey}.instruction`}
              value={field_metadata.instruction || ''}
              onChange={onInstructionChange}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              version="v2"
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
              id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
            />
          </Field>

          <Field>
            <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}-label`} className='FieldLabel__CT' htmlFor="helpText" version="v2">Help Text</FieldLabel>
            <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}-help-text`} text="Provide additional info about the field. The help text will appear when the user hovers on the ‘?’ sign beside the field name." />
            <Textarea
              name={`${uniqueKey}.helpText`}
              value={field_metadata.description || ''}
              onChange={onHelpTextChange}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              version="v2"
              showCharacterCount
              width="full"
              maxLength={256}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
              id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
            />
          </Field>
          <div className='FormFields__row_v2' >
            <div className='FormFields__column_v2' >
              <Field>
                <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.SELECTION_TYPE_DROPDOWN)}-label`} className='FieldLabel__CT' htmlFor="selectionType" version="v2">Selection Type</FieldLabel>
                <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.SELECTION_TYPE_DROPDOWN)}-help-text`} text="Select if users can choose single or multiple choices while creating entries" />

                <Dropdown
                  className="FormFields__Dropdown_v2"
                  type="select"
                  arrowSecondary={true}
                  dropDownType="primary"
                  list={selectionType}
                  closeAfterSelect={true}
                  version="v2"
                  testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.SELECTION_TYPE_DROPDOWN)}
                />
              </Field>
            </div>
            <div className='FormFields__column_v2'>
              <Field>
                <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_TYPE_DROPDOWN)}-label`} className='FieldLabel__CT' htmlFor="displayType" version="v2">Display Type</FieldLabel>
                <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_TYPE_DROPDOWN)}-help-text`} text="Decide how the choices must be displayed to the users." />

                <Dropdown
                  className="FormFields__Dropdown_v2"
                  type="select"
                  arrowSecondary={true}
                  list={displayType}
                  closeAfterSelect={true}
                  version="v2"
                  testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_TYPE_DROPDOWN)}
                />
              </Field>
            </div>
          </div>
          <div className='FormFields__row_v2' >
            <div className='FormFields__column_v2'>
              <Field>
                <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.MIN_MULTIPLE_CHOICE_LIMIT_INPUT)}-label`} className='FieldLabel__CT' htmlFor="limitMulChoices" version="v2">Limit for Multiple Choices</FieldLabel>
                <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.MIN_MULTIPLE_CHOICE_LIMIT_INPUT)}-help-text`} text="Set the minimum and maximum number of choices that can be selected while creating entry." />
                <div className="FormFields__group-fields_v2">
                  <TextInput
                    className="group-fields__item"
                    name={`${uniqueKey}.limit.min`}
                    type="number"
                    disabled={!schema.multiple}
                    placeholder={props.t('content_type.save_content_type.body.fields.common_properties.placeholders.min')}
                    value={schema.min_instance || undefined}
                    min="0"
                    onChange={onLimitMinChange}
                    error={schema.error && schema.error_details.min_instance ? true : false}
                    version="v2"
                    testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.MIN_MULTIPLE_CHOICE_LIMIT_INPUT)}
                  />
                  <span className='group-fields__connector' >to</span>
                  <TextInput
                    className="group-fields__item"
                    name={`${uniqueKey}.limit.max`}
                    type="number"
                    disabled={!schema.multiple}
                    value={schema.max_instance || undefined}
                    max="1"
                    onChange={onLimitMaxChange}
                    error={schema.error && schema.error_details.max_instance ? true : false}
                    placeholder={props.t('content_type.save_content_type.body.fields.common_properties.placeholders.max')}
                    version="v2"
                    testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.MAX_MULTIPLE_CHOICE_LIMIT_INPUT)}
                  />
                </div>
                {schema.error && schema.error_details && schema.error_details.max_instance ? (
                  <span className='field-description'
                    data-test-id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.MIN_MULTIPLE_CHOICE_LIMIT_INPUT_VALID)} >
                    {schema.error_details.max_instance}
                  </span>
                ) : schema.error && schema.error_details && schema.error_details.min_instance ? (
                  <span className='field-description'
                    data-test-id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.MAX_MULTIPLE_CHOICE_LIMIT_INPUT_VALID)}>
                    {schema.error_details.min_instance}
                  </span>
                ) : null}
              </Field>
            </div>
            <div className='FormFields__column_v2'>
              <Field>
                <FieldLabel testId='cs-ct-field-basic-select-label' className='FieldLabel__CT' htmlFor="choiceDataType" version="v2"> Choice Data Type</FieldLabel>
                <Help type="basic" text="Set a data type in which the values will be added for choices." />
                <div className="FormFields__radio_wrapper">
                  <Radio
                    testId="cs-ct-field-basic-select-text"
                    name={`${uniqueKey}.choiceDT`}
                    value="text"
                    text="Text"
                    checked={schema.data_type === 'text'}
                    onChange={onDataTypeChoiceChange}
                    version="v2"
                  />
                  <Radio
                    testId="cs-ct-field-basic-select-number"
                    name={`${uniqueKey}.choiceDT`}
                    value="number"
                    text="Number"
                    checked={schema.data_type === 'number'}
                    onChange={onDataTypeChoiceChange}
                    version="v2"
                  />
                </div>
              </Field>
            </div>
          </div>
          {schema.display_type === 'radio' && (
            <div className='FormFields__row_v2'>
              <div className='FormFields__column_v2'>
                <Field>
                  <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_HORIZONTAL_TOGGLE)}-label`} className='FieldLabel__CT' htmlFor="displayHorizontalToggle" version="v2">Display Style</FieldLabel>
                  <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_HORIZONTAL_TOGGLE)}-help-text`} text="Display radio button choices side by side in a horizontal row." />
                  <div className="DisplayStyleToggleWrap">
                    <ToggleSwitch
                      tabIndex={0}
                      name={'displayHorizontalToggle'}
                      id={'displayHorizontalToggle'}
                      checked={!!schema.field_metadata?.display_horizontal}
                      onChange={() => {
                        if (!schema.field_metadata) {
                          schema.field_metadata = {}
                        }
                        schema.field_metadata.display_horizontal = !schema.field_metadata.display_horizontal
                        onchange()
                      }}
                      label={'Display horizontally'}
                      labelPosition="right"
                      testId={booleanTestIdFormatter(getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_HORIZONTAL_TOGGLE), !!schema.field_metadata?.display_horizontal)}
                    />
                  </div>
                </Field>
              </div>
            </div>
          )}

          <FieldLabel testId='cs-ct-field-basic-select-choice-label' version='v2' htmlFor="addChoices">Choice(s)</FieldLabel>
          <div className="FormFields__sub_block">
            <Field className='LastField'>
              <div className="add-choices-with-toggle">
                <div>
                  <FieldLabel testId='cs-ct-field-basic-select-add-choice-label' version='v2' htmlFor="addChoices">Add Choice(s)</FieldLabel>
                  <Help
                    testId='cs-ct-field-basic-select-add-choice-help-text'
                    type="basic"
                    text={`Enter values that will be visible as choices to the users. A maximum of ${selectOptionsLimit} choices can be added.`}
                  />
                </div>
                <div className='ToggleWrap' >
                  <ToggleSwitch
                    tabIndex={0}
                    name={'keyValueToggle'}
                    id={'keyValueToggle'}
                    checked={schema.enum.advanced ? true : false}
                    onChange={onKeyValueToggle}
                    label={schema.enum.advanced ? 'Key-value enabled' : 'Enable key-value'}
                    labelPosition="right"
                    testId={booleanTestIdFormatter(getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.ADD_CHOICE_TOGGLE), schema.enum.advanced ? true : false)}
                  />
                </div>
              </div>
              <div className="add-choices-key-value-section">
                <form onSubmit={onAddChoices}>
                  <div className="flex">
                    <div className='flex-grow-1'>
                      <Textarea
                        name={`${uniqueKey}.addchoices`}
                        value={choices}
                        className="choices-input"
                        onChange={onChoicesChange}
                        version="v2"
                        error={
                          schema.error &&
                            (schema.error_details.add_choices ||
                              schema.error_details.max_choices ||
                              schema.error_details.duplicate_choice)
                            ? true
                            : false
                        }
                        placeholder={
                          schema.enum.advanced ? 'Enter key-value pairs here, e.g., New York:NY' : 'Enter values here'
                        }
                        testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.CHOICES_INPUT)}
                        id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.CHOICES_INPUT)}
                      />
                      <div className="add-choices-description">
                        {schema.enum.advanced ? (
                          <span>
                            Enter key-value pairs (choices) with a colon separating the key from value; press ‘Enter’ to separate multiple key-value pairs; and click the '+' sign.
                          </span>
                        ) : (
                          <span>Enter values (choices), each in a separate line, and click the '+' sign</span>
                        )}
                      </div>
                    </div>

                    <Button icon="v2-Plus" version="v2" onlyIcon onlyIconHoverColor="secondary" buttonType="tertiary" type="submit"
                      iconProps={{ size: "medium" }}
                      testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.ADD_CHOICE_BUTTON)}
                    >
                      Add
                    </Button>
                  </div>
                </form>

                <DragDropContext
                  onDragEnd={(result) => {
                    if (!result.destination) {
                      return
                    }

                    if (result.destination.index === result.source.index) {
                      return
                    }

                    schema.enum.choices = arrayMove(schema.enum.choices, result.source.index, result.destination.index)
                    onchange()
                  }}>
                  {schema.enum.choices.length > 0 && (
                    <div className="choices-table-headers">
                      Added {schema.enum.choices.length === 1 ? 'Choice' : 'Choices'}
                      <Pills items={[{ text: schema.enum.choices.length, id: 1 }]}
                        shouldHaveBorder={false}
                        background='#F7F9FC'
                      // stroke='#DDE3EE'
                      />
                    </div>
                  )}

                  <Droppable droppableId={`${uniqueKey}.choices`}>
                    {(provided) => {
                      return schema?.enum?.choices?.length ?
                        (<div ref={provided.innerRef} {...provided.droppableProps} className='SelectField__choices-container' >
                          <SortableList
                            schema={schema}
                            uniqueKey={uniqueKey}
                            field_metadata={field_metadata}
                            type={type}
                            onOptionsUpdateError={onOptionsUpdateError}
                            onchange={onchange} t={props.t} choices={schema.enum.choices} />
                          {provided.placeholder}
                        </div>)
                        : null
                    }}
                  </Droppable>
                </DragDropContext>
              </div>
            </Field>
          </div >
        </div >
      </>
    )
  } else if (type === 'advanced') {
    return (
      <>
        <div className="FormFields">
          <Field>
            <FieldLabel testId='cs-ct-field-advanced-select-options' version='v2' className='FieldLabel__CT' htmlFor="options">Other Options</FieldLabel>
            <div className="ToggleWrap">
              <ToggleSwitch
                tabIndex={0}
                testId={booleanTestIdFormatter("cs-ct-field-select-mandatory", schema.mandatory)}
                label="Mandatory"
                name={`${uniqueKey}.mandatory`}
                checked={schema.mandatory}
                onChange={onOptionsChange}
                labelPosition="right"
              />
            </div>
            {
              hasNonLocalizablePlan ? (
                hasNonLocalizablePlanForBlocksAndGroupMultiple ? (
                  <NonLocalizableDom
                    isFieldPresent={true}
                    uniqueKey={uniqueKey}
                    schema={schema}
                    onOptionsChange={onOptionsChange}
                    dataTestId={booleanTestIdFormatter(schema.nonLocParams?.insideMultiple ? `cs-ct-field-select-non-localizable-parent-multiple` : `cs-ct-field-select-non-localizable`, schema.non_localizable)}
                    dataTestIdForDescription={"cs-ct-field-select-non-localizable-description"}
                    isNonLocalizable={isNonLocalizable}
                    isAncestorNonLoc ={parentInfo.isAncestorNonLoc}
                  />
                ) : (parentInfo.hasParent ? !parentInfo.isInsideMultiple : true) ?
                  <NonLocalizableDom
                    isFieldPresent={true}
                    uniqueKey={uniqueKey}
                    schema={schema}
                    onOptionsChange={onOptionsChange}
                    dataTestId={booleanTestIdFormatter("cs-ct-field-select-non-localizable", schema.non_localizable)}
                    dataTestIdForDescription={"cs-ct-field-select-non-localizable-description"}
                    isNonLocalizable={isNonLocalizable}
                    isAncestorNonLoc ={parentInfo.isAncestorNonLoc}
                  />
                  : null
              ) : null
            }
          </Field>

          {(
            parentInfo.hasParent
              ? parentInfo.isMulti && (parentInfo.data_type == 'group')
              : false
          ) ? (
            <>
              <div className="mark-group-title">
                <div className='ToggleWrap' >
                  <ToggleSwitch
                    testId={booleanTestIdFormatter("cs-ct-field-select-group-title", field_metadata.isTitle)}
                    name={`${uniqueKey}.isTitle`}
                    label="Mark as Group title"
                    checked={field_metadata.isTitle || false}
                    onChange={(event) => {
                      let eventData = event.target.checked
                      field_metadata.isTitle = eventData
                      onchange()
                    }}
                  />
                </div>
              </div>
            </>
          ) : null}
          <GlobalFieldTitleToggle
            parentInfo={parentInfo}
            uniqueKey={uniqueKey}
            field_metadata={field_metadata}
            onchange={onchange}
            multiple={schema?.multiple}
            testId="cs-ct-field-select-global-title"
            schema={schema}
            contentTypeSchemaTree={contentTypeSchemaTree}
            isGlobalFieldBuilderPage={isGlobalFieldBuilderPage}
          />
          <ModularBlockInstanceTitleToggle
            parentInfo={parentInfo}
            uniqueKey={uniqueKey}
            field_metadata={field_metadata}
            onchange={onchange}
            multiple={schema?.multiple}
            testId="cs-ct-field-select-modular-block-instance-title"
            schema={schema}
          />
        </div>
      </>
    )
  }
}

export default React.memo(SelectField)
